import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { Dispatch, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { RootState } from 'MyTypes';

interface AuthenticationProviderProps {
    children: any;
    dispatch: Dispatch;
    authenticate: any
}


export const AuthenticationContext = React.createContext('');

export const useAuthentication = () => useContext(AuthenticationContext);

const AuthenticationProvider: React.FC<AuthenticationProviderProps> = ({ children, dispatch, authenticate }) => {

    return (
        <AuthenticationContext.Provider value="">{children}</AuthenticationContext.Provider>
    );
};

export default compose<React.ComponentType>(
    connect(({authenticate }: RootState) => ({ authenticate })),
    withRouter,
)(AuthenticationProvider);
